// extracted by mini-css-extract-plugin
module.exports = {"mask":"Image_mask__3qQ22","loading":"Image_loading__1tbyH"};